// extracted by mini-css-extract-plugin
export default {"header":"Header_header__JEZFv","main-image":"Header_main-image__czgqB"};